import React, { useState } from 'react';
import { Dialog, DialogContent, DialogTitle, IconButton, Stepper, Step, StepLabel, Button, CircularProgress, Typography, TextField } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

import PaymentPageContainer from '../paymentPageCommon/PaymentPageContainer';
import cartRemote from '../../../api/cartRemote';

import PickupOrderModel from '../../../models/PickupOrder';

interface EditGoStepperModalProps {
  open: boolean;
  onClose: () => void;
  goOrder: PickupOrderModel;
  history: any;
  userRole: any;
}

export default function EditGoStepperModal(props: EditGoStepperModalProps) {
  const [activeStep, setActiveStep] = useState(0);
  const [loading, setLoading] = useState(false);
  const [cartCalculations, setCartCalculations] = useState<any>(null);
  
  const [awbCode, setAwbCode] = useState('');
  const [awbNumber, setAwbNumber] = useState('');

  const [errorMsg, setErrorMsg] = useState('');

  const handleNext = async () => {
    if (activeStep === 0) {
      setLoading(true);
      setErrorMsg('');
      try {
        const response = await cartRemote.addAirwayBillToCart(awbCode, awbNumber, 0, props.goOrder.number);
        if (response.result) {
          setCartCalculations(response.result);
          setActiveStep(1);
        } else if (response.error) {
          setErrorMsg(response.error.longDescription || 'Failed to add AWB.');
        }
      } catch (e) {
        console.error('Failed to add AWB', e);
        setErrorMsg('Failed to add AWB to cart.');
      }
      setLoading(false);
    }
  };

  return (
    <Dialog open={props.open} onClose={() => {}} maxWidth="md" fullWidth>
      <DialogTitle>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <span>Add Airwaybill to {props.goOrder.number}</span>
          <IconButton onClick={props.onClose}><CloseIcon /></IconButton>
        </div>
      </DialogTitle>
      
      <DialogContent style={{ minHeight: '400px', padding: '20px' }}>
        <Stepper activeStep={activeStep} alternativeLabel style={{ marginBottom: '20px' }}>
          <Step><StepLabel>Enter AWB</StepLabel></Step>
          <Step><StepLabel>Review & Pay</StepLabel></Step>
        </Stepper>

        <div style={{ padding: '20px' }}>
          {activeStep === 0 && (
             <div style={{ display: 'flex', flexDirection: 'column', gap: '20px', alignItems: 'center', marginTop: '40px' }}>
               <Typography variant="h6">Enter AWB Details</Typography>
               <div style={{ display: 'flex', gap: '15px' }}>
                 <TextField label="Code (e.g. 020)" value={awbCode} onChange={(e) => setAwbCode(e.target.value)} variant="outlined" />
                 <TextField label="Number (8 digits)" value={awbNumber} onChange={(e) => setAwbNumber(e.target.value)} variant="outlined" />
               </div>
               {errorMsg && <Typography color="error">{errorMsg}</Typography>}
               
               <div style={{ marginTop: '30px' }}>
                 <Button onClick={props.onClose} style={{ marginRight: '10px' }}>Cancel</Button>
                 <Button 
                   variant="contained" 
                   color="primary" 
                   onClick={handleNext} 
                   disabled={loading || !awbCode || !awbNumber}
                 >
                   {loading ? <CircularProgress size={24} /> : 'Calculate Charges'}
                 </Button>
               </div>
             </div>
          )}

          {activeStep === 1 && (
             <div>
               <PaymentPageContainer
                  orderNumber={props.goOrder.number}
                  history={props.history}
                  userRole={props.userRole}
                  closeModal={() => { props.onClose(); window.location.reload(); }}
                  overrideAmountDue={cartCalculations ? cartCalculations.remainDue : 0}
                  overrideCartItemsLength={cartCalculations?.items ? cartCalculations.items.length : 1}
                  customHandlePayment={async (paymentOther: string, paymentType: string, stripePaymentMethodId?: string) => {
                      try {
                          const response = await cartRemote.cartPay(false, paymentOther, paymentType, stripePaymentMethodId, props.goOrder.number);
                          if (response.result) {
                              props.onClose();
                              window.location.reload();
                          }
                      } catch (e) {
                          console.error('Failed to process edit payment', e);
                      }
                  }}
               />
             </div>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
